<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="
      cn('flex items-center justify-between gap-1 px-2 pb-2', props.class)
    "
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
